import { ExpiredTokenCode, } from '@tradingblock/types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import _ from 'lodash';
import { toRawOccSymbol, isOCCSymbol } from '..';
export class WebsocketFeedParser {
    constructor(value) {
        this.str = (ind) => this.values[ind];
        this.int = (ind) => parseInt(this.str(ind));
        this.float = (ind) => parseFloat(this.str(ind));
        this.date = (ind) => dayjs(this.str(ind));
        this.success = (ind) => (this.int(ind) === 0 ? true : false);
        this.getMessageType = (typeVal) => {
            const typeValInt = this.int(typeVal);
            switch (typeValInt) {
                case 100:
                case 0:
                    return 'HeartBeat';
                case 1:
                    return 'Quote';
                case 2:
                    return 'Spread';
                case 3:
                    return 'OrderUpdate';
                case 4:
                    return 'Settlement';
                case 90:
                    return 'ExpiredToken';
                case 6:
                    return 'CashieringUpdate';
                default:
                    return undefined;
            }
        };
        this.metadata = () => {
            return {
                success: this.success(0),
                type: this.getMessageType(1),
                raw: this.raw,
            };
        };
        this.parseExpiredTokenMessage = () => {
            const metadata = this.metadata();
            const Code = this.int(2) === 10 ? ExpiredTokenCode.DuplicateLogin : ExpiredTokenCode.Unknown;
            return Object.assign({}, metadata, { Code, Reason: this.str(3), isValid: true });
        };
        this.parseQuote = () => {
            const metadata = this.metadata();
            const { QuoteTime } = { QuoteTime: this.str(2) };
            const symbol = this.str(3);
            const Symbol = isOCCSymbol(symbol) ? toRawOccSymbol(symbol) : symbol;
            return Object.assign({}, metadata, { QuoteTime,
                Symbol, LastTradePrice: this.float(4), BidPrice: this.float(5), AskPrice: this.float(6), NetChange: this.float(7), High: this.float(8), Low: this.float(9), Volume: this.float(10), ChangePercentage: this.float(11), BidSize: this.float(12), AskSize: this.float(13), isValid: dayjs(QuoteTime, 'MM/DD/YYYY HH:mm:ss').isValid() &&
                    dayjs(QuoteTime, 'MM/DD/YYYY HH:mm:ss').year() >= dayjs().year() });
        };
        this.parseOrderUpdate = () => {
            const metadata = this.metadata();
            return Object.assign({}, metadata, { AccountId: this.int(2), OrderId: this.int(3), OrderTime: this.date(4).toDate(), Symbol: this.str(5), OrderQuantity: this.float(6), FilledQuantity: this.float(7), OrderPrice: this.float(8), OrderAction: this.str(9), OrderStatus: this.int(10), Expiration: this.date(11).toDate(), CallPut: this.str(12), Strike: this.float(13), isValid: true });
        };
        this.parseSettlement = () => {
            const metadata = this.metadata();
            return Object.assign({}, metadata, { CloseDate: this.str(2), Symbol: this.str(3), ClosePrice: this.float(4), ClosePriceTMinus2: this.float(5), IsSettlementSet: true, isValid: true });
        };
        this.parseHeartbeat = () => {
            const metadata = this.metadata();
            return Object.assign({}, metadata, { isValid: true });
        };
        this.parseSpread = () => {
            const metadata = this.metadata();
            const { SpreadTime } = { SpreadTime: this.str(2) };
            const symbol = this.str(3).replace(/\./g, '');
            const Symbol = isOCCSymbol(symbol) ? toRawOccSymbol(symbol) : symbol;
            return Object.assign({}, metadata, { SpreadTime,
                Symbol, Last: this.float(4), Bid: this.float(5), Ask: this.float(6), Change: this.float(7), isValid: true });
        };
        this.parseCashieringUpdate = () => {
            const metadata = this.metadata();
            return Object.assign({}, metadata, { accountId: this.int(2), updateTime: this.date(3).toDate(), updateType: this.str(4), updateTypeId: this.int(5), status: this.str(6), isValid: true });
        };
        this.parseMap = {
            Quote: this.parseQuote,
            HeartBeat: this.parseHeartbeat,
            OrderUpdate: this.parseOrderUpdate,
            ExpiredToken: this.parseExpiredTokenMessage,
            Spread: this.parseSpread,
            Settlement: this.parseSettlement,
            CashieringUpdate: this.parseCashieringUpdate,
        };
        this.parse = () => {
            const parser = this.parseMap;
            const metadata = this.metadata();
            if (parser && metadata && metadata.type && parser[metadata.type]) {
                return parser[metadata.type]();
            }
            return undefined;
        };
        this.values = value.split('|').reduce((acc, vv) => {
            const matchVal = vv.match(/(?<fieldkey>\d+)=(?<fieldvalue>.*)/);
            if (_.isNil(matchVal)) {
                return acc;
            }
            // vv.replace(/(\d+)=/, '')
            const { fieldkey, fieldvalue } = matchVal.groups;
            const fKey = _.parseInt(fieldkey);
            if (_.isNil(fKey) || _.isNaN(fKey)) {
                return acc;
            }
            return Object.assign({}, acc, { [fKey]: fieldvalue });
        }, {});
        this.raw = value;
        // if (vals.length < 12) {
        // console.warn('quote string from feed has less fields than expected', value);
        // }
    }
}
//# sourceMappingURL=WebsocketFeedParser.js.map